import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";

const SecondaryNav = ({ isOpen, PrimaryTab }) => {
    const { t } = useTranslation();
    const pathname = window.location.pathname;
    const user = JSON.parse(localStorage.getItem('user'));
    const [secondaryTabs, setSecondaryTabs] = useState([]);

    let adminPath = [
        { label: 'Current Auction', path: "/admin/auctions/current" },
    ];

    useEffect(() => {
        switch (PrimaryTab) {
            case 'Admin':
                // 当 expression === value1 时执行的代码
                if (user?.UserType === 'SuperAdmin') {
                    const displayMore = [
                        { label: 'Customer Data', path: "/admin/CustomerData" },
                    ]
                    adminPath.push(...displayMore);
                }
                setSecondaryTabs(adminPath);
                break;
            default:
                setSecondaryTabs([]);
                break;
        }
    }, [PrimaryTab])


    return (
        <div className={`sub-nav-container sub-bar-style admin-nav ${isOpen ? 'open' : ''}`} style={{ display: `${isOpen ? '' : 'none'}` }}>
            {
                <nav className="navbar">
                    <ul className="nav-links">
                        {
                            secondaryTabs.map((item, index) => (
                                <li key={item.label} className={pathname === item.path ? 'selected pushable' : 'notSelected pushable'}>
                                    <Link to={item.path} className="front">{t(item.label)}</Link>
                                </li>
                            ))
                        }
                    </ul>
                </nav>
            }
        </div>
    );
}

export default SecondaryNav;